import Resource from '@/api/resources/Resource'

class CaseComprehensiveDiagnosisAttachmentService extends Resource {
    async addAttachment(laboratoryId, caseId, request) {
        const response = await this.axios.post(
            `/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis/attachments`,
            request)
        return response.data
    }

    async getAttachments(laboratoryId, caseId) {
        const response = await this.axios.get(`/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis/attachments`)
        return response.data
    }

    async deleteAttachment(laboratoryId, caseId, descriptionAttachmentId) {
        const response = await this.axios.delete(`/laboratories/${laboratoryId}/cases/${caseId}/comprehensiveDiagnosis/attachments/${descriptionAttachmentId}`)
        return response.data
    }
}

export default new CaseComprehensiveDiagnosisAttachmentService()
